import { pipe } from "fp-ts-esm/function";
import lodash from "lodash";
import { GALLERY_TYPE, IMAGE_TYPE } from "./../ricos-content/index.js";
import {
  convertRelObjectToString,
  convertRelStringToObject
} from "./../wix-rich-content-common/lib/link-converters.js";
import { applyBIGenerics } from "./biUtils/index.js";
import { isViewerPlugin } from "./is-viewer-plugin.js";
import { pluginsStrategy } from "./plugins-strategy.js";
const combineMappers = (mappers, ...args) => {
  if (!mappers || mappers.some((resolver) => typeof resolver !== "function")) {
    console.warn(`${mappers} is expected to be a function array`);
    return {};
  }
  return mappers.reduce((map, mapper) => Object.assign(map, mapper(...args)), {});
};
function mergeViewerProps({
  pluginConfig,
  helpers,
  isMobile,
  addAnchors,
  onError,
  mediaSettings = {},
  linkSettings = {},
  generalLinkSettings,
  textAlignment,
  experiments,
  iframeSandboxDomain,
  theme,
  plugins = [],
  content,
  viewerProps,
  onNodeClick,
  debugMode,
  jsdomMode,
  baseUrl
}) {
  const rcvPluginProps = pluginsStrategy({
    plugins: plugins?.filter(isViewerPlugin),
    viewerProps
  });
  const { pauseMedia, disableRightClick } = mediaSettings;
  const { customAnchorScroll } = linkSettings;
  let { anchorTarget = "_blank", relValue, rel } = linkSettings;
  if (relValue) {
    console.warn(
      // oxlint-disable-next-line max-len
      `relValue is deprecated, Please use rel prop instead.`
    );
    rel = convertRelStringToObject(relValue) || rel;
  }
  const { target, ...relAttributes } = generalLinkSettings?.initialLinkOptions || {};
  anchorTarget = target || anchorTarget;
  rel = { ...rel, ...relAttributes };
  relValue = convertRelObjectToString(rel);
  const disableDownload = mediaSettings?.disableDownload || disableRightClick;
  const ricosPropsToMerge = {
    addAnchors,
    isMobile,
    config: {
      uiSettings: { disableDownload }
    },
    content,
    onError,
    helpers: {},
    disabled: pauseMedia,
    anchorTarget,
    relValue,
    customAnchorScroll,
    textAlignment,
    experiments,
    iframeSandboxDomain,
    theme,
    onNodeClick,
    jsdomMode,
    baseUrl
  };
  const mergedRCProps = pipe(
    lodash.merge(
      { locale: "en", config: {} },
      rcvPluginProps,
      { config: pluginConfig, helpers },
      ricosPropsToMerge,
      viewerProps
    ),
    applyBIGenerics(() => content?.metadata?.id)
  );
  return {
    ...mergedRCProps,
    debugMode,
    plugins,
    typeMappers: combineMappers(mergedRCProps.typeMappers || [])
  };
}
function hasFullscreen(config) {
  const { [IMAGE_TYPE]: imageConfig, [GALLERY_TYPE]: galleryConfig } = config || {};
  const needsFullscreenProvider = !imageConfig?.onExpand || !galleryConfig?.onExpand;
  const isExpandDisabled = (!imageConfig || imageConfig.disableExpand) && (!galleryConfig || galleryConfig?.disableExpand);
  return !isExpandDisabled && needsFullscreenProvider;
}
export {
  hasFullscreen,
  mergeViewerProps
};
//# sourceMappingURL=utils.js.map
